/**
 * docs/05-ADMIN-DASHBOARD.md §5.10 and §6's activity log — `/users`, `/roles`
 * and `/activity`.
 */

export interface UserRow {
  id: number;
  name: string;
  email: string;
  /** The account's own picture, or null — `Avatar` falls back to initials. */
  avatar: { url: string | null; alt: string | null } | null;
  locale: string;
  is_active: boolean;
  /** §5.10's "role badges" — names, because the five are constants. */
  roles: string[];
  faculty: { id: number; name: Record<string, string | null> } | null;
  last_login_at: string | null;
  two_factor_confirmed: boolean;
  /** An invitation is outstanding until somebody has signed in with it. */
  has_signed_in: boolean;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
}

export interface UserInput {
  name: string;
  email: string;
  locale: string;
  is_active: boolean;
  roles: string[];
  faculty_id: number | null;
}

export interface RoleRow {
  id: number;
  name: string;
  permissions: string[];
  users_count: number | null;
  is_seeded: boolean;
  /** False for `super-admin`, whose permissions are not what grant it access. */
  is_editable: boolean;
  is_deletable: boolean;
}

export interface ActivityRow {
  id: number;
  event: string | null;
  log_name: string | null;
  subject: { type: string | null; id: number | null; label: string | null };
  causer: { id: number; name: string } | null;
  changes: {
    attributes: Record<string, unknown>;
    old: Record<string, unknown>;
  };
  ip: string | null;
  created_at: string | null;
}

export interface ActivityFilters {
  subject_types: string[];
  events: string[];
}

/**
 * The two the admin interface itself ships in (§6.6).
 *
 * There is deliberately no list of role names here. The five are seeded, but
 * `/admin/roles` is what the screens read — a role added through §5.10's editor
 * has to appear in the picker without a client release, and a hardcoded list is
 * how it would not.
 */
export const ADMIN_LOCALES = ['ka', 'en'] as const;
